export function scrollToTop(behavior: ScrollBehavior = "smooth") {
  try {
    const se = document.scrollingElement || document.documentElement;
    se.scrollTop = 0;
    (document.body as any).scrollTop = 0;
    window.scrollTo({ top: 0, left: 0, behavior });

    const candidates = Array.from(
      document.querySelectorAll<HTMLElement>(
        "[data-scroll-container], main, #root, .app, .layout"
      )
    );

    const container = candidates.find((el) => {
      const style = window.getComputedStyle(el);
      const oy = style.overflowY;
      return (oy === "auto" || oy === "scroll") && el.scrollHeight > el.clientHeight;
    });

    if (container) container.scrollTo({ top: 0, left: 0, behavior });
  } catch {
    window.scrollTo(0, 0);
  }
}
